import { useEffect, useState } from "react";
import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function PerformanceChart({ range }) {
  const [daily, setDaily] = useState(null);

  useEffect(() => {
    api.get("/admin/performance/summary", { params: range }).then(({ data }) => {
      setDaily(
        data.daily.map((d) => ({
          date: d.date.slice(5),
          spend: Math.round(d.spend_paise / 100),
          revenue: Math.round(d.attributed_revenue_paise / 100),
        }))
      );
    });
  }, [range]);

  if (!daily) {
    return <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-amtm-teal" /></div>;
  }

  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-xl p-4 mb-6" data-testid="performance-chart">
      <p className="font-semibold text-amtm-text mb-3">Ad Spend vs Attributed Revenue</p>
      {daily.length === 0 ? (
        <p className="text-amtm-textMuted text-sm py-10 text-center" data-testid="performance-chart-empty">No data for this range yet.</p>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart data={daily}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" fontSize={12} />
            <YAxis yAxisId="left" fontSize={12} />
            <YAxis yAxisId="right" orientation="right" fontSize={12} />
            <Tooltip formatter={(v) => `₹${v.toLocaleString("en-IN")}`} />
            <Legend />
            <Bar yAxisId="left" dataKey="spend" name="Ad Spend (₹)" fill="#0C7268" radius={[4, 4, 0, 0]} />
            <Line yAxisId="right" dataKey="revenue" name="Attributed Revenue (₹)" stroke="#F54F1B" strokeWidth={2} dot={false} />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
